import {
  CLICK_CREATE_BUTTON,
  CLICK_REFRESH_BUTTON,
  VALIDATION,
  RESET_VALIDATION,
  CHANGE_AUTO_REFRESH_TIME
} from "./actions.type";
import {
  SET_AUTO_REFRESH_TIME,
  SET_CREATE_BUTTON,
  SET_REFRESH_BUTTON,
  SET_VALIDATION_ERRORS
} from "./mutations.type";

const state = {
  validationErrors: {},
  createButton: 0,
  refreshButton: 0,
  autoRefreshTime: 30000
};

const getters = {
  createButton: state => state.createButton,
  refreshButton: state => state.refreshButton,
  validationErrors: state => state.validationErrors,
  autoRefreshTime: state => state.autoRefreshTime
};

const actions = {
  [CLICK_CREATE_BUTTON]({ commit }) {
    commit(SET_CREATE_BUTTON);
  },
  [CLICK_REFRESH_BUTTON]({ commit }) {
    commit(SET_REFRESH_BUTTON);
  },
  [VALIDATION]({ commit }, errors) {
    commit(SET_VALIDATION_ERRORS, errors);
  },
  [RESET_VALIDATION]({ commit }) {
    commit(SET_VALIDATION_ERRORS, {});
  },
  [CHANGE_AUTO_REFRESH_TIME]({ commit }, time) {
    commit(SET_AUTO_REFRESH_TIME, time);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_CREATE_BUTTON](state) {
    state.createButton++;
  },
  [SET_REFRESH_BUTTON](state) {
    state.refreshButton++;
  },
  [SET_VALIDATION_ERRORS](state, errors) {
    state.validationErrors = errors;
  },
  [SET_AUTO_REFRESH_TIME](state, time) {
    state.autoRefreshTime = time;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
